<!-- Modal -->
<p-dialog  [visible]="isAddReqVisible" [modal]="true" [style]="{ width: '90%', maxWidth:'850px' }" [closable]="false" [draggable]="false" [resizable]="false" [appendTo]="'body'">
  <ng-template #header>
    <div class="w-full">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <button class="text-[#238EC6] text-xl font-semibold" (click)="closeAddReqDialog()">
            <img src="/assets/icons/backward-arrow.svg" width="20" />
          </button>

          @if(isRequest()){
          <h2 class="text-[28px] font-bold text-heading">Request Service</h2>
          }@else {
          <h2 class="text-[28px] font-bold text-heading">Add or Request</h2>
          }
        </div>
        <button class="text-[#238EC6] text-2xl font-bold" (click)="closeAddReqDialog()">✕</button>
      </div>
    </div>
  </ng-template>

  <!-- Body -->
  <div class="mb-5">
    @for (option of requestList; track $index) {
      @if (!isRequest() || (option.title !== 'Popular Choice' && option.title !== 'Add Listings')) {
        <h4 class="text-[20px] font-bold text-heading mb-2">
          {{option.title}}
        </h4>

        <div class="grid grid-cols-[repeat(auto-fit,minmax(90px,1fr))] gap-[10px] mb-3">
          @for (item of option.items; track $index) {
            <div class="flex flex-col items-center bg-[#F2F6F8] hover:bg-[#F2F0EA] rounded-lg p-2 hover:shadow-sm transition w-[95px] h-[100px] cursor-pointer" (click)="nextStep(item.label)">
              <img [src]="item.icon" width="55" height="55" />
              <p class="text-[14px] font-semibold -mt-[5px] leading-[14px] text-center">{{item.label}}</p>
            </div>
          }
        </div>
      }
    }
  </div>
</p-dialog>

@if (isCollabAddPopupVisible) {
  <pa-add-collab (closeAddCollabPopup)="closeAddCollabPopup($event)" />
}
@if(isBookingAddPopupVisible()){
  <pa-bookings-flow-popup
    (closeBookingsFlow)="onBookingsFlowClose($event)"
    (bookingComplete)="onBookingComplete($event)"
  ></pa-bookings-flow-popup>
}
<div class="hidden">
  <pa-prime-list 
    [primes]="[]" 
    [loading]="false" 
    [canLoadMore]="false"
    >
  </pa-prime-list>
</div>

@if (isAddTaskModalOpen()) {
<pa-todo-tasks-popup
  (closeTodoPopup)="closeTodoPopup()"
  [isFromOverview]="0"
  [overviewOriginType]="''"
/>
}
@if (isAddReminderModalOpen()) {
  <pa-reminder-create (closeReminderPopup)="closeAddReminderModal($event)" [isFromOverview]="0"  [overviewOriginType]="''" />
}
@if (isAddMeetupOpen()) {
  <pa-meetup-create (closeMeetupPopup)="closeMeetupPopup()" />
}
@if(isAddAmenities()) {
  <pa-amenities-create
    (close)="closeAmenitiesPopup()"
    (requestComplete)="onRequestComplete($event)"/>
}
@if (isPaymentFlowOpen()) {
  <pa-payment-flow-popup
    [isTransaction]="!isPayRentFlow()"
    [isPayRent]="isPayRentFlow()"
    [initialTransactionType]="!isPayRentFlow() ? selectedTransactionType() : null"
    [initialPaymentType]="isPayRentFlow() ? selectedTransactionType() : null"
    (closePaymentFlow)="onPaymentFlowClose($event)"
    (paymentComplete)="onPaymentComplete($event)">
  </pa-payment-flow-popup>
}
@if (isServiceOptionPopupVisible()) {
  <pa-create-requests-popup
    [skipToLaundry]="true"
    (close)="onServiceOptionClose()"
    (requestComplete)="onRequestComplete($event)">
  </pa-create-requests-popup>
}
@if(isAddGuestEntry()) {
  <pa-guests-entry-create
    (close)="closeGuestEntryPopup()"
    (requestComplete)="onRequestComplete($event)">
  </pa-guests-entry-create>
}
@if (isAddFrontdesk()) {
  <pa-frontdesk-requests-create
    (close)="closeFrontdeskPopup()"
    (requestComplete)="onRequestComplete($event)">
  </pa-frontdesk-requests-create>
}

@if (isAddContactOpen()) {
  <pa-add-contact-popup
    [contactType]="addContactType()"
    (closeAddContactPopup)="onAddContactClose($event)">
  </pa-add-contact-popup>
}